(function() {
angular.module('agenda')
  .component('agendaListItem', {
    templateUrl: 'js/custom-components/agenda-list-item/agenda-list-item.component.html',
    bindings: {
      event: "="
    },
    controller: 'AgendaListItemComponentController',
    controllerAs: 'ctrl'
  });

})();
